import { Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import vscanService from "../../services/vscanService";
import reportService from "../../services/reportService";
import companyService from "../../services/companyService";

const VscanModal = (props) => {

	const handleRowClick = (vsr) => {
		reportService.vulnerabilityScanReport(companyService.selectedCompany, vsr.id);
	};
	
	return (
		<Dialog
			open={props.show? true : false}
			onClose={props.onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Vulnerability Scan Reports
			</DialogTitle>
			<DialogContent>
				<TableContainer component={Paper} sx={{ width: "100%" }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: "left", width: "80%" }}>Reports</TableCell>
								<TableCell sx={{ textAlign: "center", width: "20%" }}>Date</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{vscanService.vscanReports.map((vsr, i) => {
								return (
									<TableRow
										sx={{
											'&:hover': {
												cursor: "pointer",
												background: "rgba(0, 0, 0, 0.05)"
											}
										}}
										key={`vsr_row_${i}`}
										onClick={() => { handleRowClick(vsr); }}
									>
										<TableCell sx={{ textAlign: "left", width: "80%" }}>
											{vsr.filename}
										</TableCell>
										<TableCell sx={{ textAlign: "center", width: "20%" }}>
											{vscanService.getVscanDate(vsr, false)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
		</Dialog>
	);
}

export default VscanModal;